<div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="center">

        <form role="form" [formGroup]="formRegister" (ngSubmit)="onSubmit()">

            <mat-card class="register-form mat-elevation-z8" flex="80">

                <div>
                    <mat-card-title>Sign up</mat-card-title>

                    <mat-card-content fxLayout="column" fxLayoutAlign="space-around stretch">
                        <div fxLayout="row" fxLayoutAlign="space-between stretch">
                            <mat-form-field fxFlex="48">
                                <input matInput type="text" formControlName="firstname" autocomplete="firstname"
                                    placeholder="First name">
                            </mat-form-field>
                            <mat-form-field fxFlex="48">
                                <input matInput type="text" formControlName="lastname" autocomplete="lastname"
                                    placeholder="Last name">
                            </mat-form-field>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="space-between stretch">
                            <mat-form-field fxFlex="100">
                                <input matInput type="email" formControlName="email" class="form-control" value=""
                                    autocomplete="email" placeholder="E-mail">
                            </mat-form-field>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="space-between stretch">

                            <mat-form-field fxFlex="48">
                                <input matInput type="password" formControlName="password1" type="password"
                                    autocomplete="off">
                                <mat-placeholder>
                                    <mat-icon>lock</mat-icon> New password
                                </mat-placeholder>
                            </mat-form-field>
                            <mat-form-field fxFlex="48">
                                <input matInput type="password" formControlName="password2" class="form-control"
                                    autocomplete="off">
                                <mat-placeholder>
                                    <mat-icon>lock_outline</mat-icon> Password confirmation
                                </mat-placeholder>
                            </mat-form-field>
                        </div>
                    </mat-card-content>
                </div>

                <mat-card-actions fxLayoutAlign="end">
                    <span></span>
                    <button mat-raised-button color="primary" type="submit" [class.spinner]="loading"
                        [disabled]="loading || formRegister.invalid">
                        <mat-icon>done</mat-icon>&nbsp;Register
                    </button>
                </mat-card-actions>
            </mat-card>
        </form>
    </div>
</div>